import { Form, Select, Skeleton } from "antd";
import { useTranslation } from "react-i18next";

import { LANGUAGE_FIELD_NAME } from "./language-select-lang-field.constant";
import { useLanguageSelectField } from "./language-select-lang-field.hook";

// TODO DEV-8551 `Option` is deprecated. Please use `options` instead.
// eslint-disable-next-line @typescript-eslint/no-deprecated
const { Option } = Select;

const SelectLangField = () => {
  const { t } = useTranslation();
  const { languages, isLoading } = useLanguageSelectField();
  const languageOptions = languages.map((language) => (
    <Option key={language.code} value={language.code}>
      {language.name}
    </Option>
  ));

  return (
    <Form.Item
      name={LANGUAGE_FIELD_NAME}
      label={t("global:language.label")}
      required={true}
      rules={[{ required: true }]}
    >
      {isLoading ? (
        <Skeleton.Input active />
      ) : (
        <Select>{languageOptions}</Select>
      )}
    </Form.Item>
  );
};

export default SelectLangField;
